import {
    USER_GET_ALL_SUBSCRIPTIONS_START,
    USER_GET_ALL_SUBSCRIPTIONS_FAIL,
    USER_GET_ALL_SUBSCRIPTIONS_FINISH,
    USER_GET_ALL_SUBSCRIPTIONS
} from '../../actions/types';

const INITIAL_STATE = {
    subscriptions: [],
    error: '',
    loading: false,
};


export default (state = INITIAL_STATE, action) => {
    switch (action.type) {
        case USER_GET_ALL_SUBSCRIPTIONS_START:
            return { ...state, loading: true };
        case USER_GET_ALL_SUBSCRIPTIONS_FINISH:
            return { ...state, loading: false };
        case USER_GET_ALL_SUBSCRIPTIONS_FAIL:
            return { ...state, error: { [action.payload.props]: action.payload.value } };
        case USER_GET_ALL_SUBSCRIPTIONS:
            return { ...state, subscriptions: action.payload };
        default:
            return state;
    }
};

